import {
  IWorkingTimeDay,
  TimeStates,
} from 'features/working-hours-picker/interfaces/time-table-input.interface';
import React, { useEffect, useMemo, useState } from 'react';
import { DEFAULT_TIME_RANGE } from 'shared/consts/schedule';
import { CustomTimePicker } from '../custom-time-picker/custom-time-picker';
import styles from './time-range-picker.module.scss';

interface ITimeRangePicker {
  index: number;
  timeRange: IWorkingTimeDay;
  value?: string;
  timeInterval?: number;
  onChange: (data: { dayIndex: number; timeRange: IWorkingTimeDay }) => void;
}

export const TimeRangePicker: React.FC<ITimeRangePicker> = ({
  index,
  value,
  timeRange,
  timeInterval = 10,
  onChange,
}) => {
  const [startTime, setStartTime] = useState<string | null>(timeRange.start);
  const [endTime, setEndTime] = useState<string | null>(timeRange.end);
  useEffect(() => {
    onChange({
      dayIndex: index,
      timeRange: { start: startTime, end: endTime },
    });
  }, [startTime, endTime]);

  const onChangeHandler = (key: number | string, time: string) => {
    const newTimeRange: IWorkingTimeDay = { start: null, end: null };
    Object.assign(newTimeRange, timeRange);
    newTimeRange[key as TimeStates] = time;
    setStartTime(newTimeRange[TimeStates.start]);
    setEndTime(newTimeRange[TimeStates.end]);
  };
  const timeOptions = useMemo(() => {
    const interval = Math.max(1, timeInterval);
    const options: string[] = [];
    let hour = 0;
    let minute = 0;

    while (hour < 24) {
      const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      options.push(time);

      minute += interval;
      if (minute >= 60) {
        minute = 0;
        hour++;
      }
    }

    const startIndex =
      options.indexOf(startTime !== null ? startTime : DEFAULT_TIME_RANGE[0]) +
      1;
    const endIndex = options.indexOf(
      endTime !== null ? endTime : DEFAULT_TIME_RANGE[1]
    );
    return {
      start: options.slice(0, endIndex),
      end: options.slice(startIndex),
    };
  }, [timeInterval, startTime, endTime]);

  const { start, end } = timeRange ?? {
    start: DEFAULT_TIME_RANGE[0],
    end: DEFAULT_TIME_RANGE[1],
  };

  let result = <></>;
  if (!value && start !== null && end !== null) {
    result = (
      <div key={index} className={styles.day__times}>
        <div className={styles.times__time}>
          <div className={styles.times__time}>
            <CustomTimePicker
              value={startTime !== null ? startTime : DEFAULT_TIME_RANGE[0]}
              index={TimeStates.start}
              onChange={onChangeHandler}
              timeOptions={timeOptions.start}
            />
          </div>
        </div>
        <span>&mdash;</span>
        <div className={styles.times__time}>
          <div className={styles.times__time}>
            <CustomTimePicker
              value={endTime !== null ? endTime : DEFAULT_TIME_RANGE[1]}
              index={TimeStates.end}
              onChange={onChangeHandler}
              timeOptions={timeOptions.end}
            />
          </div>
        </div>
      </div>
    );
  } else {
    result = (
      <div key={index} className={styles.day__times}>
        {value}
      </div>
    );
  }
  return result;
};
